import Api from "./Api";
import Csrf from "./Csrf";

export default {   
    
  async update(id,form) {
    await Csrf.getCookie();

    return Api.patch("/locks/"+id, form);
  },
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/locks");
  },
	
  async free() {
    await Csrf.getCookie();

    return Api.get("/locks/free");
  },
    
  async add(form) {
    await Csrf.getCookie();

    return Api.post("/locks", form);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/locks/" + id);      
      
  },
    
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/locks/" + id);      
      
  },
};